import { Edit, EditProps, SimpleForm, useRedirect, useRefresh } from 'react-admin';
import { TurnReferencesEnum, TurnResourcesEnum } from '@/types/turn-enums';
import { NationalRecord } from '@/types/turn-api';
import FormContent from './FormContent';

const NationalRecordEdit = (props: EditProps) => {
  const redirect = useRedirect();
  const refresh = useRefresh();

  const redirectToNationalTab = (data: NationalRecord) => {
    redirect(`/${TurnReferencesEnum.Candidates}/${data?.pw}/show/${TurnResourcesEnum.NationalRecords}`);
    refresh();
  };

  return (
    <Edit
      title={'Edit National Record Entry'}
      mutationOptions={{ onSuccess: redirectToNationalTab }}
      mutationMode="pessimistic"
      {...props}
    >
      <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
        <FormContent onClose={redirectToNationalTab} {...props} />
      </SimpleForm>
    </Edit>
  );
};

export default NationalRecordEdit;
